import { css } from "styled-components";

// 기기 사이즈
export const size = {
	mobileS: "320px",
	mobileM: "375px",
	mobileL: "425px",
	tablet: "768px",
	laptop: "1024px",
	laptopL: "1440px",
	desktop: "2560px",
};

// 미디어 스타일
const theme = {
	mobileS: `(max-width: ${size.mobileS})`,
	mobileM: `(max-width: ${size.mobileM})`,
	mobileL: `(max-width: ${size.mobileL})`,
	tablet: `(max-width: ${size.tablet})`,
	laptop: `(max-width: ${size.laptop})`,
	laptopL: `(max-width: ${size.laptopL})`,
	desktop: `(min-width: ${size.desktop})`,
	desktopL: `(min-width: ${size.desktop})`,
};

// color
export const color = {
	white: "#F3F2F2",
	black: "#141414",
	purple: "#481C63",
	lightGreen: "#5D5E55",
	green: "#F3F2F2",
	darkGreen: "#262626",
	red: "#9C203E",
	yellow: "#686A0E",
	blue: "#19394B",
	violet: "#2C194B",
};

// flex 디자인
export const flexCenter = css`
	display: flex;
	justify-content: center;
`;

export const flexCenterDir = css`
	${flexCenter}

	flex-direction: column;
`;

export const pageSetting = css`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	width: 100vw;
	/* background: lightGray; */
	box-sizing: border-box;
	overflow-y: auto;

	::-webkit-scrollbar {
		display: none;
	}
`;

export const fullPage = css`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100vw;
	height: 100vh;
`;

export const intaglio = css`
	display: flex;
	/* background: #111111; */
	background: #262626;
	/* box-shadow: inset -1px 2px 4px #282828; */
	border-radius: 0.3rem;
`;

export const levelBtn = css`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 7rem;
	height: 43px;
	border-radius: 10px;
	color: #f3f2f2;
`;

export const overflowY = css`
	overflow-y: auto;
	::-webkit-scrollbar {
		display: none;
	}
`;

export const fadeIn = css`
	animation: fade-in 3s;

	@keyframes fade-in {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
`;

export type Theme = typeof theme;
